import { render, staticRenderFns } from "./BracketItemControls.vue?vue&type=template&id=772ff280"
import script from "./BracketItemControls.vue?vue&type=script&lang=js"
export * from "./BracketItemControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports